<!--  -->
<template>
    <div class="docBody"  style="height:100%;"     v-loading="loading"> 
            <!-- <div :style="{backgroundImage:'url('+imgUrl+')'}" class="tt">
            </div> --> 
            <div  v-if="showImg" style="height:100%;overflow:scroll;"> 
                <img  style="width:100%;"   :src="imgUrl" />
            </div>
            
        <!-- <div  style="margin:0 auto;background-color:l"> -->
            <div  v-if="showWord" class="docxRef" style="width: 100%;height:100vh;overflow:scroll">
            </div>
        <!-- </div> -->
        <vue-office-pdf style="height:100vh" v-if="showPdf" :src="pdfUrl" @rendered="rendered" />
    </div>
</template>

<script>
function getPng(res, that) {
    let type;
    that.showImg = true
    if (that.currentFileType == 'jpeg'  || that.currentFileType == 'jpg') {
        type = 'image/jpeg'
    } else if (that.currentFileType == 'png') {
        type = 'image/png'
    }
    let url = window.URL.createObjectURL(
        new File([res.data], { type: type })
    );
    that.imgUrl = url

}
function getPdf(res, that) {
    that.showPdf = true
    const disposition = res.headers["content-disposition"];
    const fileName = decodeURI(disposition);
    const blob = new Blob([res.data]);
    let url = window.URL.createObjectURL(
        new File([res.data], { type: 'application/pdf' })
    );

    that.pdfUrl = url
}

function getWord(res, that) {
    that.showWord = true
    const disposition = res.headers["content-disposition"];
    const fileName = decodeURI(disposition);
    const blob = new Blob([res.data]);
    let url = window.URL.createObjectURL(
        new File([res.data], { type: 'application/msword' })
    );
    let docxOptions = {
        inWrapper: false, // boolean：启用围绕文档内容的包装器渲染
        ignoreWidth: false, // boolean：禁用页面的渲染宽度
        ignoreHeight: false, // boolean：禁止渲染页面高度
        ignoreFonts: false, // boolean：禁用字体渲染
        breakPages: true, // boolean：在分页符上启用分页
        ignoreLastRenderedPageBreak: false, // boolean：在 lastRenderedPageBreak 元素上禁用分页
        experimental: true, // boolean：启用实验功能（制表符停止计算）
        trimXmlDeclaration: false, // boolean：如果为true，解析前会从​​ xml 文档中移除 xml 声明
        useBase64URL: false,
        useMathMLPolyfill: false,
        showChanges: false,
        debug: false,
    };
    let childRef = document.getElementsByClassName("docxRef");
    window.setTimeout(()=>{
        // that.$message({
        //         message: '成功生成文件内容',
        //         type: "success",
        //  });
        renderAsync(blob, childRef[0], null, docxOptions);
    },100)

}
import VueOfficePdf from '@vue-office/pdf'
import { renderAsync } from "docx-preview";
import util from "@/libs/util";
import axios from "axios";

export default {
    //import引入的组件需要注入到对象中才能使用
    components: {
        VueOfficePdf
    },
    props: [
        'id', 'currentFileType', 'url', 'isValidate'
    ],
    data() {
        //这里存放数据
        return {
            loading:true,
            imgUrl: '',
            showPdf: false,
            showWord: false,
            showImg: false,
            pdfUrl: '',
            fileType: [
                {
                    'png': 'image/png',
                    fn: getPng
                },
                {
                    'jpg': 'image/jpeg',
                     fn: getPng
                },
                {
                    'pdf': 'application/pdf',
                    fn: getPdf
                },
                {
                    'doc': 'application/msword',
                    fn: getWord
                },
                {
                    'jpeg': 'image/jpeg',
                    fn: getPng
                },
                {
                    'docx': 'application/msword',
                    fn: getWord
                }
            ],
        };
    },
    //监听属性 类似于data概念
    computed: {},
    //监控data中的数据变化
    watch: {},
    //方法集合
    methods: {
        rendered(){
        },
        getDoc() {
            // var form = new FormData();
            // form.append("caseIdList", [11793]);
            // let data = {
            //     caseId: 11793,
            //     documentName: '起诉状',
            // };
    
            if (this.isValidate) {
                validateNull(form).then((response) => {
                    if (response.statusCode !== 2000) {
                        this.showDoc = false;
                        this.$message({
                            message: "无法获取判决书：" + response.message,
                        });
                        return;
                    } else {
                        this.showDoc = true;
                        const token = util.cookies.get("token");
                        axios({
                            url: process.env.VUE_APP_API + "/api/case/czCaseFiles/previewFile/" + this.fileId,
                            method: "post",
                            responseType: "arraybuffer",
                            data: data,
                            headers: {
                                // 项目中请求头需要的信息（如果不需要可不写），如用户登录信息验证：
                                authorization: "Bearer " + token,
                            },
                        }).then((res) => {
                            this.loading = false;
                            const disposition = res.headers["content-disposition"];
                            const fileName = decodeURI(disposition);
                            const blob = new Blob([res.data]);
                            let url = window.URL.createObjectURL(
                                new File([res.data], { type: "application/msword" })
                            );
                            this.$message({
                                message: '成功',
                                type: "success",
                            });
                            this.docx = url;
                            let docxOptions = {
                                inWrapper: false, // boolean：启用围绕文档内容的包装器渲染
                                ignoreWidth: false, // boolean：禁用页面的渲染宽度
                                ignoreHeight: false, // boolean：禁止渲染页面高度
                                ignoreFonts: false, // boolean：禁用字体渲染
                                breakPages: true, // boolean：在分页符上启用分页
                                ignoreLastRenderedPageBreak: false, // boolean：在 lastRenderedPageBreak 元素上禁用分页
                                experimental: true, // boolean：启用实验功能（制表符停止计算）
                                trimXmlDeclaration: false, // boolean：如果为true，解析前会从​​ xml 文档中移除 xml 声明
                                useBase64URL: false,
                                useMathMLPolyfill: false,
                                showChanges: false,
                                debug: false,
                            };

                            // this.docx = `http://localhost:9572/image/aaz.docx`
                            //  const blob = new Blob([this.docx],{type:"application/msword"})
                            let childRef = document.getElementsByClassName("docxRef");
                            renderAsync(blob, childRef[0], null, docxOptions);
                        });
                    }
                });
            } else {
            //     let loading = this.$loading({
            //     lock: true,
            //     text: "正在生成内容",
            //     spinner: "el-icon-loading",
            //     background: "rgba(0, 0, 0, 0.7)",
            // });
                const token = util.cookies.get("token");
                axios({
                    url: process.env.VUE_APP_API + this.url + this.id,
                    method: "post",
                    responseType: "arraybuffer",
                    headers: {
                        // 项目中请求头需要的信息（如果不需要可不写），如用户登录信息验证：
                        authorization: "Bearer " + token,
                    },
                }).then((res) => {
                 //    loading.close();
                    this.loading = false
 
                    for (let i = 0; i < this.fileType.length; i++) {
                        if (this.fileType[i][this.currentFileType]) {
                            this.fileType[i].fn(res, this)
                        }
                    }

                });
            }



        },
    },
    //生命周期 - 创建完成（可以访问当前this实例）
    created() {
    },
    //生命周期 - 挂载完成（可以访问DOM元素）
    mounted() {
        this.getDoc()
    },
    beforeCreate() { }, //生命周期 - 创建之前
    beforeMount() { }, //生命周期 - 挂载之前
    beforeUpdate() { }, //生命周期 - 更新之前
    updated() {
        // this.getDoc()
    }, //生命周期 - 更新之后
    beforeDestroy() { }, //生命周期 - 销毁之前
    destroyed() { }, //生命周期 - 销毁完成
    activated() { 
    }, //如果页面有keep-alive缓存功能，这个函数会触发
}
</script>
<style scoped>
.docBody >>>.docx {
    padding: 72pt 40pt !important;
    
}
/* .tt{
    width:100vw;
    height: 100vh;
} */
</style>